import { render, staticRenderFns } from "./CreateVehicleModal.vue?vue&type=template&id=66c5d460&scoped=true"
import script from "./CreateVehicleModal.vue?vue&type=script&lang=js"
export * from "./CreateVehicleModal.vue?vue&type=script&lang=js"
import style0 from "./CreateVehicleModal.vue?vue&type=style&index=0&id=66c5d460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c5d460",
  null
  
)

export default component.exports